import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import { mixins } from 'vue-class-component';
import JhiDataUtils from '@/shared/data/data-utils.service';
import { File, IFile } from '../commons/file.model';

@Component({
  inheritAttrs: false,
})
export default class InputImageComponent extends mixins(JhiDataUtils) {
  @Prop({ required: true })
  id: string;

  @Prop({ default: '' })
  label: string;

  @Prop({ default: true })
  readonly: boolean;

  @Prop({ default: true })
  valid: boolean;

  @Prop({ required: true })
  public value!: any;

  public temporal = null;

  get file(): any {
    if (!this.value) {
      return new File();
    } else {
      return this.value;
    }
  }

  set file(newValue: any) {
    this.$emit('input', newValue);
  }

  @Watch('file.content')
  onContentChanged(val: string, oldVal: string) {
    this.$emit('input', this.file);
  }

  @Watch('file.contentType')
  onContentTypeChdanged(val: string, oldVal: string) {
    this.$emit('input', this.file);
  }

  setFileData(event, entity, field, isImage) {
    if (event && event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (isImage && !/^image\//.test(file.type)) {
        return;
      }
      this.toBase64(file, base64Data => {
        entity[field] = base64Data;
        entity[`contentType`] = file.type;
      });
    }
  }
}
